<template>
  <div class="card">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * BaseCard - Card wrapper component
 * 
 * Provides a styled card container with rounded corners and shadow.
 * Content is provided via default slot.
 * 
 * @example
 * <base-card>
 *   <h2>Title</h2>
 *   <p>Content goes here</p>
 * </base-card>
 */
export default defineComponent({
  name: 'BaseCard'
});
</script>

<style scoped>
.card {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-4);
  margin: var(--spacing-8) auto;
  max-width: 40rem;
  background: var(--color-bg-primary);
  transition: var(--transition-base);
}

.card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}
</style>
